"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.next = exports.listUntil = exports.nextMonth = exports.lastDayOfMonth = exports.firstDayOfMonth = exports.dateToStr = exports.timeToStr = exports.cloneDate = exports.dateWalk = exports.parseTime = exports.parseDate = exports.MONTHS = exports.DAY = exports.pad = void 0;
function pad(n) {
    return n < 10 ? '0' + n : n;
}
exports.pad = pad;
exports.DAY = 24 * 60 * 60 * 1000;
exports.MONTHS = "janeiro,fevereiro,março,abril,maio,junho,julho,agosto,setembro,outubro,novembro,dezembro".split(",");
function parseDate(str, defaultDate) {
    if (str == null)
        return defaultDate;
    var m = null;
    if (m = str.match(/^(\d{2})\/(\d{2})\/(\d{4})/))
        return new Date(parseInt(m[3]), parseInt(m[2]) - 1, parseInt(m[1]));
    return defaultDate;
}
exports.parseDate = parseDate;
function parseTime(str) {
    var m = null;
    if (m = str === null || str === void 0 ? void 0 : str.match(/(\d{2}):(\d{2})$/))
        return { minute: parseInt(m[2]), hour: parseInt(m[1]) };
    return { minute: 0, hour: 0 };
}
exports.parseTime = parseTime;
function dateWalk(date, step, limit) {
    if (limit(date))
        return date;
    date.setTime(date.getTime() + step);
    return dateWalk(date, step, limit);
}
exports.dateWalk = dateWalk;
function cloneDate(d) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
exports.cloneDate = cloneDate;
function timeToStr(time) {
    return "".concat(pad(time.hour), ":").concat(pad(time.minute));
}
exports.timeToStr = timeToStr;
function dateToStr(date, time) {
    if (time)
        return dateToStr(date) + " - ".concat(pad(time.hour), ":").concat(pad(time.minute));
    return "".concat(pad(date.getDate()), "/").concat(pad(date.getMonth() + 1), "/").concat(date.getFullYear());
}
exports.dateToStr = dateToStr;
function firstDayOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
exports.firstDayOfMonth = firstDayOfMonth;
function lastDayOfMonth(date) {
    var result = nextMonth(date);
    result.setDate(0);
    return result;
}
exports.lastDayOfMonth = lastDayOfMonth;
function nextMonth(date) {
    var result = cloneDate(date);
    result.setDate(1);
    result.setMonth(result.getMonth() + 1);
    return result;
}
exports.nextMonth = nextMonth;
function listUntil(date, ok) {
    date = cloneDate(date);
    var result = [];
    while (ok(date)) {
        result.push(date);
        date = next(date);
    }
    return result;
}
exports.listUntil = listUntil;
function next(date) {
    var result = cloneDate(date);
    result.setDate(result.getDate() + 1);
    return result;
}
exports.next = next;
//# sourceMappingURL=utils.js.map